export default __webpack_public_path__ + "static/media/step4.ad3a81bd.svg";